import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { Preguntas } from '@interfaces/preguntas.interface';
import { PreguntasIngresoExtraComponent } from '../preguntas-ingreso-extra/preguntas-ingreso-extra.component';

@Component({
  selector: 'app-preguntas',
  templateUrl: './preguntas.component.html',
  styleUrls: ['./preguntas.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, IonicModule, PreguntasIngresoExtraComponent]
})
export class PreguntasComponent {

  @Input() question!: Preguntas;
  @Input() form!: FormGroup;
  @Input() index!: number;
  @Input() total!: number;
  @Input() isActive = false;
  @Input() resumenRefreshToken = 0;
  @Output() requestToggle = new EventEmitter<boolean>();
  @Output() saveAmount = new EventEmitter<void>();

  detailsOpen = false;

  toggleDetail() {
    this.detailsOpen = !this.detailsOpen;
  }

  activateQuestion() {
    this.requestToggle.emit(true);
  }

  onChildSave() {
    this.saveAmount.emit();
  }
}
